import { Button } from "src/components";
import crossIcon from "src/assets/cross.svg";
import { useState } from "react";
import { useToast } from "src/hooks/useToast";
import { eInvoiceStatusUpdate } from "src/services/invoice-api";
import { useEventStatus } from "src/hooks/useEventStatus";
import { getEInvoiceReferenceErrors, requiresIrn } from "./eInvoiceReference"; // M10-16235

interface InvoiceAcceptProps {
  onCloseModal: () => void;
  einvoice_dtl_id: number;
  primary_key: number;
  onSuccess: () => void;
  eInvoiceData: any;
  einvoiceRefType: string; // M10-16235
  irnNumber: string; // M10-16235
}

const InvoiceAccept = ({ onCloseModal, einvoice_dtl_id, primary_key, onSuccess, eInvoiceData, einvoiceRefType, irnNumber }: InvoiceAcceptProps) => {
  const [remarks, setRemarks] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { withEventCheck } = useEventStatus();

  const { toast } = useToast();

  const fetchCurrentEInvoice = async () => {
    onSuccess();
  };

  const handleAcceptInvoice = async () => {
    //M10-11909
    if (!remarks.trim()) {
      toast({ description: "Remarks should not empty", variant: "destructive" });
      return;
    }
    //M10-11909
    // M10-16235
    const refErrors = getEInvoiceReferenceErrors(einvoiceRefType, irnNumber);
    if (refErrors.refType || refErrors.irn) {
      toast({ description: refErrors.refType || refErrors.irn, variant: "destructive" });
      return;
    }
    setIsLoading(true);
    const payload = {
      data: {
        einvoice_dtl_id: einvoice_dtl_id,
        einvoice_status: "accepted",
        remarks: remarks,
        reference_number: remarks,  //M10-11909
        reason: "Verified", // MEDVOL: M10-10639 changes
        mapped_fuid_number: eInvoiceData?.mapped_fuid_number,
        einvoice_ref_type: einvoiceRefType, // M10-16235
        irn_number: requiresIrn(einvoiceRefType) ? irnNumber.trim() : eInvoiceData?.irn_number || '',
        attachment_type: eInvoiceData?.einvoice_attachment?.attachment_type,
        stockist_invoice_attachment_id: primary_key,  //M10-11909
        invoice_id: eInvoiceData?.stockistInvoiceAttachment?.invoice?.invoice_id //M10-11685 - e-inv unblock stockist
      },
      primary_key: primary_key,
      event_type: "E_INVOICE_STATUS_UPDATE",
    };

    try {
      const response = await eInvoiceStatusUpdate(payload, eInvoiceData?.stockistInvoiceAttachment?.company_code);
      console.log("res", response);
      const res = await withEventCheck(() => fetchCurrentEInvoice(), response?.data?.data?.eventStreamCreated?.streamId,eInvoiceData?.stockistInvoiceAttachment?.company_code); //M10-12758
      console.log("res", res);
      toast({ description: "Invoice accepted successfully", variant: "default" });
      onCloseModal();
    } catch (error: any) {
      toast({ description: error?.response?.data?.message, variant: "destructive" });
    } finally {
      setIsLoading(false);
      onCloseModal();
    }
  };

  return (
    <div className="flex flex-col gap-y-2 w-[345px] mx-auto bg-white p-4 border border-gray-300 shadow-lg rounded-xl">
      <div className="flex justify-between items-center">
        <p className="text-normal py-1 font-semibold text-[#1B1A1F]">Accept E-Invoice</p>
        <Button className="bg-transparent -mr-3" onClick={onCloseModal}>
          <img src={crossIcon} alt="cross" className="w-5 h-5 font-bold invert cursor-pointer" />
        </Button>
      </div>
      {/* <p className="text-sm mt-2 font-normal text-[#666666]">Select Accept Reason</p>
      <Autocomplete
        inputClassName="w-full py-2"
        placeholder="Select Accept Reason"
        suggestionList={acceptReasons}
        displayKey="value"
        uniqueKey="key"
        onSelectionChange={(e: any) => setAcceptCategory(e?.key)}
      /> */}
      <p className="text-sm mt-2 font-normal text-[#666666]">Remarks</p>
      <textarea value={remarks} onChange={(e) => setRemarks(e.target.value)} placeholder=" " className="p-2 mb-2 resize-none border bg-[#f7f7f7] max-h-[120px] h-[120px] border-gray-300 rounded-md" />
      <div className="flex justify-end gap-x-2 pt-2">
        <Button className="font-normal h-8 bg-gray-200 rounded-md border border-gray-300 shadow-sm" onClick={onCloseModal}>
          Back
        </Button>{" "}
        <Button
          isLoading={isLoading}
          loaderSize="medium"
          className="font-normal text-white h-8 border rounded-md border-[#8051FF] shadow-sm bg-[#8051FF]"
          onClick={handleAcceptInvoice}
        >
          Proceed
        </Button>
      </div>
    </div>
  );
};

export default InvoiceAccept;
